import getPlayfieldPosition from './playfieldPosition';
import './Powerup.css';

function Powerup({ powerup }) {
  const labels = {
    rapidFire: 'RF',
    spreadShot: 'SP',
    optionDrone: 'OD',
    pulseBomb: 'PB',
    shield: 'SH',
    bonus: 'BO',
  };

  return (
    <div
      className={`powerup powerup-${powerup.type}`}
      style={getPlayfieldPosition(powerup.x, powerup.y)}
      aria-hidden="true"
    >
      <span className="powerup-icon" />
      <span className="powerup-label">{labels[powerup.type] ?? 'PU'}</span>
    </div>
  );
}

export default Powerup;
